import { useState } from "react";
import { Formik, Form as FormikForm } from "formik";
import Form from "react-bootstrap/Form";
import * as yup from "yup";
import axios from "axios";
import InputGroup from "react-bootstrap/InputGroup";
import { useApiContext } from "../../context/ApiContext";
import DeleteBtnModal from "../../components/DeleteBtnModal";
import CategoryTable from "./CategoryTable";

const initialValues = {
  name: "",
  c_status: "",
};

const schema = yup.object().shape({
  name: yup.string().required("Category Name is a required field!"),
  c_status: yup.string(),
});

const validate = (values) => {
  let errors = {};

  return errors;
};

const Category = () => {
  const { category } = useApiContext();
  const [message, setMessage] = useState();
  const [item, setItem] = useState({});

  const AddCategoryFunc = async (values) => {
    let formfield = new FormData();

    formfield.append("name", values.name);
    formfield.append("c_status", values.c_status);

    await axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_CATEGORY_URL}`,
      data: formfield,
    })
      .then((response) => {
        setMessage(response.success, "Category is successfuly created...");
        window.location.reload(false);
      })
      .catch((error) => {
        setMessage(error.message, "Error");
      });
  };

  const submitAddCategoryForm = async (
    values,
    { setErrors, setSubmitting, resetForm }
  ) => {
    try {
      AddCategoryFunc(values);
      setSubmitting(false);
      // resetForm();
    } catch (error) {
      setErrors({ error: error.message });
    }
  };

  const updatedValues = {
    name: item.name ? item.name : "",
    c_status: item.c_status ? item.c_status : "",
  };

  const UpdateCategoryFunc = async (values) => {
    let formfield = new FormData();

    formfield.append("name", values.name);
    formfield.append("c_status", values.c_status);

    await axios({
      method: "PUT",
      url: `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_CATEGORY_URL}${item.id}/`,
      data: formfield,
    })
      .then((response) => {
        setMessage(response.success, "Category is successfully updated...");
        window.location.reload(false);
      })
      .catch((error) => {
        setMessage(error.message, "Error");
      });
  };

  const submitUpdateCategoryForm = async (
    values,
    { setErrors, setSubmitting }
  ) => {
    try {
      UpdateCategoryFunc(values);
      setSubmitting(false);
    } catch (error) {
      setErrors({ err: error.message });
    }
  };

  const updateCategory = async (id) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_CATEGORY_URL}${id}/`
    );
    setItem(data);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-6">
                <div className="mx-3 my-2 page-title-box d-sm-flex align-items-center justify-content-start">
                  <h4 className="mb-sm-0">Category</h4>
                </div>
              </div>

              <div className="col-6">
                <div className="d-flex mx-3 my-2  align-items-center justify-content-end">
                  <button
                    className="btn btn-secondary mb-4"
                    data-bs-toggle="modal"
                    data-bs-target="#CategoryAddModal"
                  >
                    <i className="bi bi-plus-circle align-baseline me-1"></i>{" "}
                    Add Category
                  </button>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <CategoryTable
                        category={category}
                        updateCategory={updateCategory}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!--Add Modal --> */}
      <div
        className="modal fade"
        id="CategoryAddModal"
        tabIndex="-1"
        aria-labelledby="CategoryAddModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <Formik
              initialValues={initialValues}
              validationSchema={schema}
              onSubmit={submitAddCategoryForm}
              validate={validate}
            >
              {({
                handleSubmit,
                handleChange,
                values,
                touched,
                errors,
                isSubmitting,
              }) => (
                <FormikForm noValidate onSubmit={(e) => handleSubmit(e)}>
                  <div className="modal-header">
                    <h5 className="modal-title" id="CategoryAddModalLabel">
                      Add Category
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      id="close-addAgentModal"
                    ></button>
                  </div>

                  <div className="modal-body">
                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Category Name<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Control
                          type="text"
                          name="name"
                          id="name"
                          value={values.name}
                          onChange={handleChange}
                          isInvalid={!!touched.name && !!errors.name}
                          isValid={touched.name && !errors.name}
                          className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Status<span></span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Select
                          name="c_status"
                          id="c_status"
                          value={values.c_status}
                          onChange={handleChange}
                          isInvalid={!!touched.c_status && !!errors.c_status}
                          isValid={touched.c_status && !errors.c_status}
                          className="form-control"
                        >
                          <option value="">Select</option>
                          <option value={`${true}`}>Active</option>
                          <option value={`${false}`}>Inactive</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.c_status}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </div>

                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button type="reset" className="btn btn-danger">
                        Cancel
                      </button>

                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                      >
                        Add
                      </button>
                    </div>
                  </div>

                  {/* message  */}
                  {message && <h2 className="text-center m-5">{message}</h2>}
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
      </div>

      {/* update Modal */}
      <div
        className="modal fade"
        id="CategoryUpdateModal"
        tabIndex="-1"
        aria-labelledby="CategoryUpdateModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <Formik
              enableReinitialize={true}
              initialValues={updatedValues}
              validationSchema={schema}
              onSubmit={submitUpdateCategoryForm}
              validate={validate}
            >
              {({
                handleSubmit,
                handleChange,
                values,
                touched,
                errors,
                isSubmitting,
              }) => (
                <FormikForm noValidate onSubmit={(e) => handleSubmit(e)}>
                  <div className="modal-header">
                    <h5 className="modal-title" id="CategoryUpdateModalLabel">
                      Update Category
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      id="close-addAgentModal"
                    ></button>
                  </div>

                  <div className="modal-body">
                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Category Name<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Control
                          type="text"
                          name="name"
                          id="name"
                          value={values.name}
                          onChange={handleChange}
                          isInvalid={!!touched.name && !!errors.name}
                          isValid={touched.name && !errors.name}
                          className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Status<span></span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Select
                          name="c_status"
                          id="c_status"
                          value={values.c_status}
                          onChange={handleChange}
                          isInvalid={!!touched.c_status && !!errors.c_status}
                          isValid={touched.c_status && !errors.c_status}
                          className="form-control"
                        >
                          <option value="">Select</option>
                          <option value={`${true}`}>Active</option>
                          <option value={`${false}`}>Inactive</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.c_status}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </div>

                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button type="reset" className="btn btn-danger">
                        Cancel
                      </button>

                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                      >
                        Update
                      </button>
                    </div>
                  </div>

                  {/* message  */}
                  {message && <h2 className="text-center m-5">{message}</h2>}
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
      </div>

      <DeleteBtnModal id={`CategoryDeleteModal`} />
    </>
  );
};

export default Category;
